





















































































import { Vue, Component } from "vue-property-decorator";
import { ActionSheet, Cell, Checkbox, CheckboxGroup, Dialog } from "vant";
import flightService from "@/service/flightService";
import hotelService from "@/service/hotelService";
import trainService from "@/service/trainService";
import * as _ from "lodash";
import flightDetail from "@/views/order/flight/flightDetail.vue";
import hotelDetail from "@/views/order/hotel/hotelDetail.vue";
import trainDetail from "@/views/order/train/trainDetail.vue";
import { FlightOrderEntity } from "@/model/Flight";
import { ServiceType } from "@/model/Base";
import flightPolicyService from "@/service/flightPolicyService";
@Component({
  components: {
    [ActionSheet.name]: ActionSheet,
    [Cell.name]: Cell,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    flightDetail,
    hotelDetail,
    trainDetail,
  },
})
export default class extends Vue {
  errorTips = "";
  isShowVerify = false;
  verifyModel: any = {};
  //data
  productData: any = {};
  consumers: any = {};
  result: any[] = [];
  consumerResult: any[] = [];
  amendPrice = 0;
  reasonShow = false;
  actions = [
    { CategoryID: 1805, name: this.$root.$t("mall_modules_refund_hangchengbiangeng") as string, CategoryCode: "HotelChange", className: "itemClass" },
    { CategoryID: 1837, name: this.$root.$t("mall_modules_refund_hangchengquxiao") as string, CategoryCode: "HotelDelay" },
  ];
  flightActions = [
    { CategoryID: 1517, name: this.$root.$t("mall_modules_refund_woyaogaibianhangchengbuxiangfeiliao") as string, CategoryCode: "FlightChange", className: "itemClass" },
    { CategoryID: 1518, name: this.$root.$t("mall_modules_refund_jicuohangchengriqishijianxingming") as string, CategoryCode: "FlightMistaken", className: "itemClass" },
    { CategoryID: 1519, name: this.$root.$t("mall_modules_refund_hangbanyanwuhuoquxiao") as string, CategoryCode: "FlightDelay" },
  ];
  reasonVal = this.$root.$t("mall_modules_refund_genjuguisidechalvbiaozhunqingxuanzetuidingyuanyin") as string;
  DepartDate: Date = new Date();
  ArriveDate: Date = new Date();
  ReasonType = 0;
  title = this.$root.$t("mall_modules_refund_shenqingtuipiao") as string;
  comName = "";
  isShowLoading = false;

  get UniqueID(): string {
    return (this as any).$route.query.UniqueID;
  }
  get ServiceCode(): string {
    return (this as any).$route.query.ServiceCode;
  }
  get RuleType(): string {
    return (this as any).$route.query.RuleType;
  }
  get amendAmount() {
    let amendPrice = this.amendPrice;
    if (amendPrice && amendPrice > 0) {
      amendPrice = amendPrice * ((this.consumerResult && this.consumerResult.length) || 1);
    } else {
      amendPrice = this.totalPrice();
    }
    if (amendPrice && amendPrice > 0) {
      return "￥" + amendPrice;
    }
    return "-";
  }
  //mounted
  mounted() {
    if (this.ServiceCode == "Hotel") {
      this.title = this.$root.$t("mall_modules_refund_shenqingtuifang") as string;
    }
    this.comName = this.ServiceCode.toLowerCase() + "Detail";
  }
  // methods
  setResult(value: any) {
    this.result = value;
    if (this.ServiceCode == "Flight") {
      this.ComputePrice();
    };
  }
  setConsumerResult(value: any) {
    this.consumerResult = value;
  }
  totalPrice() {
    let price: number = 0;
    _.forEach(this.productData, item => {
      _.forEach(item.Goods, el => {
        _.forEach(el.Prices, o => {
          price += o.SalesPrice;
        });
      });
    });
    this.amendPrice = price;
    return price;
  }

  ComputePrice() {
    let __self = this;
    // __self.model.AmendPrice = 0;
    // if (__self.Amend.Products.length == 0 || __self.Amend.Consumers.length == 0 || __self.changetype !=          'isRefund') {
    //     return;
    // }
    if (!__self.order || !__self.order.Policys) return 0;

    let Prices: any[] = [];
    let Products = [];
    let Policys = __self.order.Policys;
    for (let i = 0; i < Policys.length; i++) {
      let Policy = Policys[i];
      if (!Policy.Goods || Policy.Goods.length == 0) {
        continue;
      }
      Policy.Goods.forEach((o: any) => {
        o.Prices.forEach((m: any) => {
          Prices.push(m);
        })
      });
      if (!Policy.Products || Policy.Products.length == 0) {
        continue;
      }
      Policy.Products.forEach((o: any) => {
        o.LevelNames = o.LevelName;
        Products.push(o)
      });
    }


    let amendProducts = this.result;
    let data: any = {};
    data.Products = []
    data.CompanyID = __self.order.CompanyID
    data.ClientID = __self.order.ClientID
    data.BusinessType = 1799;
    data.ApplyArea = __self.order.ApplyArea
    data.Prices = []
    data.Policys = Policys;
    data.UniqueID = __self.order.UniqueID;

    for (var p = 0; p < amendProducts.length; p++) {
      var prodEnt = amendProducts[p]
      data.Products.push({
        ProductID: prodEnt.ProductID,
        ConsumerDate: prodEnt.ConsumerDate,
        ConsumerZoneCode: prodEnt.ConsumerZoneCode,
        FinishedZoneCode: prodEnt.FinishedZoneCode,
        ProduceCode: prodEnt.ProduceCode,
        LevelCode: prodEnt.LevelCode
      })

      _.filter(Prices, n => n.ProductID == prodEnt.ProductID).forEach(o => data.Prices.push({
        ProductID: prodEnt.ProductID,
        PriceType: o.PriceType,
        SalesPrice: o.SalesPrice,
        MarketPrice: o.MarketPrice,
        StandardPrice: o.StandardPrice
      }));
    }
    // if(__self.order.ServiceType == __self.ServiceTypeTypes.HotelService){
    //     __self.model.AmendPrice = __self.hotelRefundPrice.RefundAmount
    //     __self.model.ChangePrice = __self.hotelRefundPrice.RefundPrice
    //     return
    // }
    // __self.loading = true;
    if (Policys[0].SourceCode == "MUNDC") {
      // flightPolicyService.getndcamendprice(__self.order.UniqueID).then(p => {
      //     if (!p.data.isSucc) {
      //         return;
      //     } 
      //     __self.model.AmendPrice = p.data.result;
      // })
    } else {
      flightPolicyService.GetChangeOrderPrice(data).then((p: any) => {
        if (!p.isSucc) return;
        let amendPrice = 0;
        amendProducts.forEach((product: any) => {
          amendPrice += _.sumBy(p.result, (p: any) => {
            return p.ProductID == product.ProductID && p.BusinessType == 1799 ? p.Price : 0;
          });
        });
        this.amendPrice = amendPrice;
      })
    }
    return 0;
  }

  closePopup() {
    if (this.isShowVerify) {
      this.isShowVerify = false;
      this.verifyModel.id = this.UniqueID;
      trainService.validAccountById(this.verifyModel).then(json => {
        if (!json.isSucc || !json.result) {
          return this.$root.$toast(json.message!);
        }
        if (this.resolveCreateAmend) {
          this.resolveCreateAmend();
        }
      });
    }
  }
  resolveCreateAmend: any = null;
  submitReview() {
    let __self = this;
    if (this.result.length < 1) {
      return this.$root.$toast(this.$root.$t("mall_modules_refund_qingxuanzexuyaotuidingdelvcheng") as string);
    }
    if (this.consumerResult.length < 1) {
      return this.$root.$toast(this.$root.$t("mall_modules_refund_qingxuanzelvke") as string);
    }
    if (!this.ReasonType) {
      return this.$root.$toast(this.$root.$t("mall_modules_refund_qingxuanzetuidingyuanyin") as string);
    }
    const data: any = {
      OriginID: this.UniqueID,
      Consumers: [],
      Products: [],
      ReasonType: this.ReasonType + "",
      CreateMode: 1405,
    };
    data.Consumers = _.map(this.consumerResult, item => ({ OriginID: item.ConsumerID }));
    data.Products = _.map(this.result, item => ({ OriginID: item.ProductID }));

    this.isShowLoading = true;
    if (this.ServiceCode == "Hotel") {
      handleCreateAmend(hotelService, data);
    } else if (this.ServiceCode == "Flight") {
      // console.log(this.order);
      var opl9 = this.order.ServiceType == ServiceType.FlightService && _.find(this.order.ExtraInfos, p => p.ExtraData == "OPL9");
      // opl9 = _.find(this.order.ExtraInfos, p => p.ExtraData == "InvoiceAndItinerary");
      if (opl9) {
        Dialog.confirm({
          confirmButtonText: "继续提交订单",
          cancelButtonText: "暂不提交订单",
          cancelButtonColor: "#1989fa",
          message: "由于你选择的是航空公司官网特惠机票，如需改期将通过航空公司官方客服热线操作，退票将通过航空公司官方操作，并且退款仅限乘客本人境内银行卡!",
          messageAlign: "left",
          closeOnPopstate: true,
        })
          .then(() => {
            handleCreateAmend(flightService, data);
          })
          .catch(() => {
            this.isShowLoading = false;
          });
      } else {
        handleCreateAmend(flightService, data);
      }
    } else {
      trainService.checkAmend(this.UniqueID).then(json => {
        if (!json.isSucc) {
          __self.verifyModel.code = "";
          __self.errorTips = json.message!.replace("该账号需要手机发短信核验_", "");
          __self.isShowVerify = __self.errorTips.indexOf("发送短信666") > -1;
          __self.isShowLoading = false;
          this.resolveCreateAmend = () => {
            handleCreateAmend(trainService, data);
          };
          return;
        }
        handleCreateAmend(trainService, data);
      });
    }
    function handleCreateAmend(ServiceType: any, datas: any) {
      __self.isShowLoading = true;
      ServiceType.CreateAmend(data).then((res: any) => {
        if (res.isSucc) {
          __self.isShowLoading = false;
          __self.$root.$toast(__self.$root.$t("mall_modules_refund_tuipiaoshenqingtijiaochenggong") as string);
          __self.$router.push("/order/list");
        } else {
          __self.isShowLoading = false;
          Dialog.alert({
            message: res.message,
            closeOnPopstate: true,
          })
            .then(() => { })
            .catch(() => { });
        }
      });
    }
  }
  formatDate(value: Date, format: string = "HH:mm") {
    if (!value) {
      return value;
    }
    return (this as any).$moment(value).format(format);
  }
  reasonSelect(value: any) {
    this.reasonVal = value.name;
    this.ReasonType = value.CategoryID;
    this.reasonShow = false;
  }
  ContactName = "";
  ContactPhone = "";
  ContactEmail = "";
  order: FlightOrderEntity = new FlightOrderEntity();
  // 获取联系人信息
  setProductData(value?: any) {
    this.order = value;

    this.ContactName = value.ContactName!;
    this.ContactPhone = value.ContactPhone!;
    this.ContactEmail = value.ContactEmail!;
  }
  back(): void {
    history.back();
  }
}
